<script>
	import HeaderCmp from './components/Header.svelte'
	import HeroCmp from './components/Hero.svelte'
	import CompanyValuesCmp from './components/CompanyValues.svelte'
	// import PartnersCmp from './components/Partners.svelte'
	import AboutUsCmp from './components/AboutUs.svelte'
	import ProductsCmp from './components/Products.svelte'
	import FooterCmp from './components/Footer.svelte'
</script>

<HeaderCmp />
<main>
	<HeroCmp />
	<CompanyValuesCmp />
	<AboutUsCmp />
	<ProductsCmp />
	<!-- <PartnersCmp /> -->
</main>
<FooterCmp />
